<template>
    <li class="accordion__item">
        <div
                class="accordion__trigger"
                :class="{'accordion__trigger_active': visible}"
                @click="open">

            <span v-if="visible" class="icon icon-arrow-up"></span>
            <span v-if="!visible" class="icon icon-arrow-down"></span>
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <slot name="accordion-trigger">
            </slot>
        </div>

        <transition
                name="accordion"
                @enter="start"
                @after-enter="end"
                @before-leave="start"
                @after-leave="end">

            <div class="accordion__content"
                 v-show="visible">
                <ul>
                    <!-- This slot will handle all the content that is passed to the accordion -->
                    <slot name="accordion-content"></slot>
                </ul>
            </div>
        </transition>
    </li>
</template>


<script>
    export default {
        props: {
            active:{
                type:Boolean,
                default:false
            }
        },
        inject: ["Accordion"],
        data() {
            return {
                visible: false
            };
        },
        methods: {
            open() {
                this.visible = !this.visible;
            },
            start(el) {
                el.style.height = el.scrollHeight + "px";
            },
            end(el) {
                el.style.height = "";
            }
        },
        created() {
            this.index = this.Accordion.count++;
            this.visible = this.active;
        }
    };
</script>

<style lang="scss" scoped>
    .accordion__item {
        cursor: pointer;
        border-bottom: 10px solid transparent;
        position: relative;
    }

    .accordion__content {
        padding: 1rem;
        background-color: #F2F2F4;
        cursor: default;
    }

    .accordion__trigger {
        display: inline-flex;
        justify-content: flex-start;
        padding: 0 1rem 0 1rem;
        font-size: .9em;
        font-weight: normal;
        background-color: #fff;
        width: 100%;
        color: #394956;
        align-items: center;
    }

    .accordion-enter-active,
    .accordion-leave-active {
        will-change: height, opacity;
        transition: height 0.3s ease, opacity 0.3s ease;
        overflow: hidden;
    }

    .accordion-enter,
    .accordion-leave-to {
        height: 0 !important;
        opacity: 0;
    }

    .icon {
        display: inline-block;
        margin-right: 1rem;
    }

    ul {
        padding: 0;
        list-style-type: none;
    }
</style>
